export default __webpack_public_path__ + "static/PXI-Logo-1-0516a9e014d732c3fb24ec291736a344.png";